export const items = [
  [
    {
      name: 'About Us',
      icon: '/UserActivity.svg',
      link: '/about'
    },
    {
      name: 'News',
      icon: '/News.svg',
      link: '/news'
    },
     {
      name: "Events",
      icon: '/UserActivity.svg',
      link: '/events'
    },
    {
      name: 'Contact',
      icon: '/ComplianceTracking.svg',
      link: '/contact'
    },
  ]
];

export const label = 'Company';
